export const ROLES_SUPERADMIN = 'SuperAdmin';
export const ROLES_ADMIN = 'Admin';
export const ROLES_USER = 'User';
export const ROLES_GUEST = 'Guest';
